import { Market } from "../../contracts";
import { CardConfiguration, LeaguesConfiguration } from "../../typings";
import { groupMarketsBySport, filterMarkets, filterOutrightsMarkets, prepareOutrightMarkets } from "../../helpers";

export const prepareMarkets = (markets: Market[], cardConfig: CardConfiguration, specialLeagues: LeaguesConfiguration, outrightMarketIds: string[]): Market[] => {
    let marketsF: Market[] = [];

    // 1. Filter outrights
    let outrightsMarkets = prepareOutrightMarkets(markets, outrightMarketIds);

    // 2. Group markets by sport and store them in an object
    let regularMarkets = filterOutrightsMarkets(false, markets, outrightMarketIds);
    let marketsBySport = groupMarketsBySport(regularMarkets, cardConfig);

    // 3. Fill empty selections for each sport
    marketsBySport = filterMarkets(marketsBySport, cardConfig, specialLeagues);

    // 4. Fill prepared markets into array
    Object.keys(marketsBySport).forEach(key => {
        marketsBySport[key].length && marketsF.push(...marketsBySport[key]);
    });

    return [...marketsF, ...outrightsMarkets];
}